<template>
  <div id="Register">
    <h2>Sign Up</h2>
    <div class="p-grid p-fluid">
    <div class="p-col-12 p-md-4">
        <div class="p-inputgroup">
        <span class="p-inputgroup-addon">
            <i class="pi pi-user"></i>
        </span>
            <InputText placeholder="email" />
            <InputText placeholder="Password" />
        </div>
    </div>
    </div>
                  <router-link to="/">Back</router-link>
  </div>
</template>

<script>
import { fb_auth } from "../firebase";
//firebase.auth().createUserWithEmailAndPassword(email, password).catch(function(error) {
  // Handle Errors here.
  //var errorCode = error.code;
  //var errorMessage = error.message;
  // ...
//});
export default {
  name: 'Sign up',
  methods: {
    RegisterUser() {
      if (this.email && this.password) {
        fb_auth
          .createUserWithEmailAndPassword(this.email, this.password)
          .then(() => {
            console.log("user:", fb_auth.currentUser);
            this.$router.push({ path: "/dashboard" });
            //route to dashboard
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            if (errorCode == "auth/wrong-password") {
              errorCode = "Incorrect Password";
            }
            var errorMessage = error.message;
            console.log(errorCode, errorMessage);
            this.$toast.add({
              severity: "error",
              summary: "errorcode",
              detail: "Login Message",
              life: 3000,
            });
          });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Form Incomplete",
          detail: this.email
            ? "Password cannot be empty."
            : "Email cannot be empty",
          life: 3000,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#login {
  color: #999999;
}

</style>